import { gql } from '@reverbdotcom/commons/src/gql';
import { ChildProps } from '@apollo/client/react/hoc';
import React from 'react';

import { IUserContext, withUserContext } from '@reverbdotcom/commons';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

import { CoreHomepageDependencies } from '@reverbdotcom/commons/src/gql/graphql';

import {
  BuyingGuidesOrCategories,
  DealsAndSteals,
  FromYourFeed,
  FromYourWatchlist,
  HolidayEmbedLow,
  HolidayEmbedMid,
  HolidayPromotionalBanner,
  HomepageRecentlyViewedListings,
  HomepageSearchRecommendations,
  JustListedForYou,
  PromotedListingsRow,
  RecentArticles,
  RecommendedCspsRow,
  RecommendedForYou,
  RecommendedForYouCP,
  RegionalListings,
} from './logged_in/content_components';

export function DefaultHomepageContent() {
  return (
    <>
      <HomepageRecentlyViewedListings />
      <FromYourFeed />
      <FromYourWatchlist />
      <JustListedForYou />
      <DealsAndSteals />
      <RecommendedForYouCP />
      <RecommendedForYou />
      <HolidayPromotionalBanner />
      <HolidayEmbedMid />
      <HolidayEmbedLow />
      {/* Listings in {{COUNTRY}} */}
      <RegionalListings />
      <BuyingGuidesOrCategories />
      <RecentArticles />
      {/*
        Promoted Listings
      */}
      <PromotedListingsRow />
    </>
  );
}

export function HomepageContentWithoutFeedRow() {
  return (
    <>
      <HolidayPromotionalBanner />
      <HomepageRecentlyViewedListings />
      <HolidayEmbedMid />
      <FromYourWatchlist />
      {/* Recent Searches with Trending Searches Fallback */}
      <HomepageSearchRecommendations />
      <HolidayEmbedLow />
      <JustListedForYou />
      <RecommendedForYouCP />
      <DealsAndSteals />
      <RecommendedForYou />
      {/* Listings in {{COUNTRY}} */}
      <RegionalListings />
      <RecommendedCspsRow />
    </>
  );
}

export function HomepageContentWithFeedRow() {
  return (
    <>
      <HomepageRecentlyViewedListings />
      <FromYourWatchlist />
      <FromYourFeed />
      <HolidayPromotionalBanner />
      <HolidayEmbedMid />
      <HolidayEmbedLow />
      {/* Recent Searches with Trending Searches Fallback */}
      <HomepageSearchRecommendations />
      <RecommendedForYouCP />
      <DealsAndSteals />
      <RecommendedForYou />
      {/* Listings in {{COUNTRY}} */}
      <RegionalListings />
      {/* Just Listed for You (displays at bottom of page for mid-high signal users) */}
      <JustListedForYou />
    </>
  );
}

type Props = ChildProps<IUserContext, CoreHomepageDependencies.Query>;

export const MIN_LISTINGS_TO_DISPLAY_FEED = 6;

function LoggedInHomepage(props: Props) {
  const shouldUseFeedRow = (props.data.me?.feed?.total || 0) >= MIN_LISTINGS_TO_DISPLAY_FEED;
  const HomepageContent = shouldUseFeedRow ? HomepageContentWithFeedRow : HomepageContentWithoutFeedRow;

  return (
    <div className="mt-gap-row">
      <HomepageContent />
    </div>
  );
}

export const HOMEPAGE_DEPENDENCIES_QUERY = gql(`
  query Core_HomepageDependencies {
    me {
      uuid
      feed(input: { channel: REVERB, limit: 0 }) {
        total
      }
    }
  },
`);

const withHomepageDependencies = withGraphql<IUserContext, CoreHomepageDependencies.Query, CoreHomepageDependencies.Variables>(
  HOMEPAGE_DEPENDENCIES_QUERY,
  {
    options: {
      ssr: true,
    },
  },
);

export default withUserContext(withHomepageDependencies(LoggedInHomepage));
